import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page"
  }, [_c("template", {
    slot: "header"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "关键字"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "关键字"
    },
    model: {
      value: _vm.searchForm.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "searchKey", $$v);
      },
      expression: "searchForm.searchKey"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.search
    }
  }, [_c("i", {
    staticClass: "fa fa-search"
  }), _vm._v(" 查询")]), _vm.buttonPerms(_vm.$route.path + ":add") ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.add
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加")]) : _vm._e()], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "320"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.buttonPerms(_vm.$route.path + ":code_list") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.detailList(scope.row);
            }
          }
        }, [_vm._v("二维码列表")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":code_down") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.download(scope.row.id);
            }
          }
        }, [_vm._v("批量下载")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":code_list") || _vm.buttonPerms(_vm.$route.path + ":code_down") || scope.row.validState == "Valid" && _vm.buttonPerms(_vm.$route.path + ":cancel") || _vm.buttonPerms(_vm.$route.path + ":del") ? _c("el-dropdown", {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            size: "mini",
            "split-button": "",
            type: "primary"
          },
          on: {
            command: _vm.moreButton
          }
        }, [_vm._v(" 更多 "), _c("el-dropdown-menu", {
          attrs: {
            slot: "dropdown"
          },
          slot: "dropdown"
        }, [_vm.buttonPerms(_vm.$route.path + ":detail") ? _c("el-dropdown-item", {
          attrs: {
            icon: "el-icon-tickets",
            command: _vm.beforeCommand(scope.$index, scope.row, "detail")
          }
        }, [_vm._v("批次详情")]) : _vm._e(), scope.row.validState == "Valid" && _vm.buttonPerms(_vm.$route.path + ":cancel") ? _c("el-dropdown-item", {
          attrs: {
            icon: "el-icon-tickets",
            command: _vm.beforeCommand(scope.$index, scope.row, "cancel")
          }
        }, [_vm._v("批次作废")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":del") ? _c("el-dropdown-item", {
          attrs: {
            icon: "el-icon-delete",
            command: _vm.beforeCommand(scope.$index, scope.row, "del")
          }
        }, [_vm._v("删除")]) : _vm._e()], 1)], 1) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "productName",
      label: "产品名称",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "productCode",
      label: "产品编码",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "generateAmount",
      label: "生成数量",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "generateState",
      label: "生成状态",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.generateState == "Ing" ? _c("div", [_vm._v("生成中")]) : _vm._e(), scope.row.generateState == "End" ? _c("div", [_vm._v("生成结束")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "validState",
      label: "使用状态",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.validState == "Valid" ? _c("div", [_vm._v("有效")]) : _vm._e(), scope.row.validState == "Cancel" ? _c("div", [_vm._v("作废")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "limitScan",
      label: "限制扫描次数",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.limitScan == "No_Limit" ? _c("div", [_vm._v("不限制")]) : _vm._e(), scope.row.limitScan == "Limit" ? _c("div", [_vm._v("限制")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "scanAmount",
      label: "扫描次数",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "validTime",
      label: "有效期截止",
      sortable: "custom",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.validTime ? _vm.dayjs(scope.row.validTime).format("YYYY-MM-DD HH:mm:ss") : "--"))])];
      }
    }])
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.searchForm.page,
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  }), _c("el-dialog", {
    attrs: {
      visible: _vm.editDialogShow,
      title: _vm.editDialogTitle,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialogShow = $event;
      },
      close: function close($event) {
        return _vm.initFormData(_vm.emptyFormData);
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "所属企业",
      "label-width": _vm.formLabelWidth,
      prop: "labId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择所属企业"
    },
    model: {
      value: _vm.formData.labName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "labName", $$v);
      },
      expression: "formData.labName"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.lab_show = !_vm.lab_show;
      }
    }
  }, [_vm._v("选择")])], 1)]), _c("el-form-item", {
    attrs: {
      label: "溯源批次",
      "label-width": _vm.formLabelWidth,
      prop: "sourceBatchId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      readonly: "",
      placeholder: "请选择溯源批次"
    },
    model: {
      value: _vm.formData.productName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productName", $$v);
      },
      expression: "formData.productName"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.batch_show = true;
      }
    }
  }, [_vm._v("选择")])], 1)]), _c("el-form-item", {
    attrs: {
      label: "生成数量",
      "label-width": _vm.formLabelWidth,
      prop: "generateAmount"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入生成数量"
    },
    model: {
      value: _vm.formData.generateAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "generateAmount", $$v);
      },
      expression: "formData.generateAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "限制扫描次数",
      "label-width": _vm.formLabelWidth,
      prop: "limitScan"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "No_Limit"
    },
    model: {
      value: _vm.formData.limitScan,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "limitScan", $$v);
      },
      expression: "formData.limitScan"
    }
  }, [_vm._v("不限制")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Limit"
    },
    model: {
      value: _vm.formData.limitScan,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "limitScan", $$v);
      },
      expression: "formData.limitScan"
    }
  }, [_vm._v("限制")])], 1), _vm.formData.limitScan == "Limit" ? _c("el-form-item", {
    attrs: {
      label: "扫描次数",
      "label-width": _vm.formLabelWidth,
      prop: "scanAmount"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入扫描次数"
    },
    model: {
      value: _vm.formData.scanAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "scanAmount", $$v);
      },
      expression: "formData.scanAmount"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "有效期截止",
      "label-width": _vm.formLabelWidth,
      prop: "validTime"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      placeholder: "选择时间",
      format: "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.formData.validTime,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "validTime", $$v);
      },
      expression: "formData.validTime"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.closeEditDialogShow
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitFormData
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm.batch_show ? _c("sourceBatchSel", {
    on: {
      "child-batch-sel": _vm.sourceBatchSel
    }
  }) : _vm._e(), _c("el-dialog", {
    attrs: {
      visible: _vm.detailDialogShow,
      title: "详情",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.detailDialogShow = $event;
      },
      close: function close($event) {
        _vm.detailDialogShow = false;
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.detailData
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "产品名称",
      "label-width": _vm.formLabelWidth,
      prop: "productName"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      readonly: "",
      placeholder: "请选择产品名称"
    },
    model: {
      value: _vm.detailData.productName,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "productName", $$v);
      },
      expression: "detailData.productName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "产品编码",
      "label-width": _vm.formLabelWidth,
      prop: "productCode"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      readonly: "",
      placeholder: "请选择产品编码"
    },
    model: {
      value: _vm.detailData.productCode,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "productCode", $$v);
      },
      expression: "detailData.productCode"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "生成状态",
      "label-width": _vm.formLabelWidth,
      prop: "generateState"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Ing"
    },
    model: {
      value: _vm.detailData.generateState,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "generateState", $$v);
      },
      expression: "detailData.generateState"
    }
  }, [_vm._v("生成中")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "End"
    },
    model: {
      value: _vm.detailData.generateState,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "generateState", $$v);
      },
      expression: "detailData.generateState"
    }
  }, [_vm._v("生成结束")])], 1), _c("el-form-item", {
    attrs: {
      label: "生成数量",
      "label-width": _vm.formLabelWidth,
      prop: "generateAmount"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入生成数量"
    },
    model: {
      value: _vm.detailData.generateAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "generateAmount", $$v);
      },
      expression: "detailData.generateAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "限制扫描次数",
      "label-width": _vm.formLabelWidth,
      prop: "limitScan"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "No_Limit"
    },
    model: {
      value: _vm.detailData.limitScan,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "limitScan", $$v);
      },
      expression: "detailData.limitScan"
    }
  }, [_vm._v("不限制")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Limit"
    },
    model: {
      value: _vm.detailData.limitScan,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "limitScan", $$v);
      },
      expression: "detailData.limitScan"
    }
  }, [_vm._v("限制")])], 1), _vm.detailData.limitScan == "Limit" ? _c("el-form-item", {
    attrs: {
      label: "扫描次数",
      "label-width": _vm.formLabelWidth,
      prop: "scanAmount"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入扫描次数"
    },
    model: {
      value: _vm.detailData.scanAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "scanAmount", $$v);
      },
      expression: "detailData.scanAmount"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "使用状态",
      "label-width": _vm.formLabelWidth,
      prop: "validState"
    }
  }, [_c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Valid"
    },
    model: {
      value: _vm.detailData.validState,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "validState", $$v);
      },
      expression: "detailData.validState"
    }
  }, [_vm._v("有效")]), _c("el-radio", {
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      label: "Cancel"
    },
    model: {
      value: _vm.detailData.validState,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "validState", $$v);
      },
      expression: "detailData.validState"
    }
  }, [_vm._v("作废")])], 1), _c("el-form-item", {
    attrs: {
      label: "有效期截止",
      "label-width": _vm.formLabelWidth,
      prop: "validTime"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      placeholder: "选择时间",
      format: "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyyMMddHHmmss"
    },
    model: {
      value: _vm.detailData.validTime,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "validTime", $$v);
      },
      expression: "detailData.validTime"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "创建时间",
      "label-width": _vm.formLabelWidth,
      prop: "createTime"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      placeholder: "选择时间",
      format: "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyyMMddHHmmss"
    },
    model: {
      value: _vm.detailData.createTime,
      callback: function callback($$v) {
        _vm.$set(_vm.detailData, "createTime", $$v);
      },
      expression: "detailData.createTime"
    }
  })], 1)], 1), _c("div", {
    staticClass: "mask"
  })], 1), _vm.lab_show ? _c("labSel", {
    on: {
      "child-lab-sel": _vm.labSel
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };